import { Component, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { GalleryService } from '../../../../core/services/gallery.service';
import { Album } from '../../../../core/models/gallery.model';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  private galleryService = inject(GalleryService);
  hasGalleryData$: Observable<boolean> = this.galleryService.getAlbums().pipe(
    map((albums: Album[]) => (albums || []).some(a => 
      a.status === 'ACTIVE' && 
      a.shown !== false && 
      a.pictureDetailsList && 
      a.pictureDetailsList.some(pic => pic.status === 'ACTIVE')
    ))
  );

  mobileMenuOpen = false;
  scrolled = false;
  showIsoCert = false;

  constructor(private router: Router) {}

  @HostListener('window:scroll')
  onScroll() {
    this.scrolled = window.scrollY > 20;
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
  }

  scrollTo(sectionId: string) {
    this.closeMobileMenu();
    
    // Check if we are on a course detail page or not on the home page
    if (this.router.url !== '/' && !this.router.url.startsWith('/#')) {
      this.router.navigate(['/']).then(() => {
        // Wait for the component to render before scrolling
        setTimeout(() => {
          const el = document.getElementById(sectionId);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      });
    } else {
      const el = document.getElementById(sectionId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  toggleIsoCert() {
    this.showIsoCert = !this.showIsoCert;
  }

  
}
